<app-input-form-modal
  [modalConfig]="modalConfig"
  (cancel)="onCancel()"
  (save)="onSave($event)"
  [isAddressModal]="true"
>
</app-input-form-modal>
